module.exports = __webpack_public_path__ + "img/ic-time.64ece207.svg";